import { Formik, Form, Field, ErrorMessage } from "formik";
import React from "react";
import * as Yup from "yup";
import request from "services/request";
import toast from "react-hot-toast";

    const DeleteAccount = () => {
  const initialValues = {
    fullName: "",
    email: "",
    collegeName: "",
    reason: "",
  };

  const validationSchema = Yup.object({
    fullName: Yup.string().trim().required("Full name is required"),
    email: Yup.string()
      .trim()
      .email("Invalid email address")
      .required("Email is required"),
    collegeName: Yup.string().required("Please select a college"),
    reason: Yup.string()
      .trim()
      .required("Please provide a reason to delete your account"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    // Transform form values to match backend payload format
    const payload = {
      name: values.fullName,
      email: values.email,
      college: values.collegeName,
      reasonToDelete: values.reason,
    };
    
    setSubmitting(true);
    const response = await request.post("/user/deletion-request", payload);
    if(response?.status){
        toast.success("Request submitted successfully");
        resetForm();
    } else {
        toast.error("Failed to submit request");
    }
    setSubmitting(false);
  };

  return (
    <section className="py-12">
      <div className="max-w-xl mx-auto px-5">
        <div className="shadow rounded-lg p-6 border border-[#E5E5E5]">
        {/* HEADING */}
        <div className="pb-3 border-b border-[#E5E5E5]">
          <h1 className="text-4xl font-source font-bold text-black">
            Delete Account
          </h1>
        </div>

        {/* DESCRIPTION */}
        <p className="mt-5 text-lg font-source text-greyText max-w-3xl">
          Fill out the form below to request permanent deletion of your Alumni
          Connection Hub account. Our team will review your request and contact
          you on the registered email if needed.
        </p>

        {/* FORM */}
        <div className="mt-8 max-w-2xl">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form className="space-y-6">
                {/* Full Name */}
                <div className="flex flex-col space-y-2">
                  <label
                    htmlFor="fullName"
                    className="text-sm font-source font-semibold text-black"
                  >
                    Full Name<span className="text-red-500">*</span>
                  </label>
                  <Field
                    id="fullName"
                    name="fullName"
                    type="text"
                    placeholder="Enter your full name"
                    className="w-full rounded-md border border-[#E5E5E5] px-3 py-2 text-base font-source text-black focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                  />
                  <ErrorMessage
                    name="fullName"
                    component="div"
                    className="text-sm text-red-500"
                  />
                </div>

                {/* Email */}
                <div className="flex flex-col space-y-2">
                  <label
                    htmlFor="email"
                    className="text-sm font-source font-semibold text-black"
                  >
                    Email used to create account
                    <span className="text-red-500">*</span>
                  </label>
                  <Field
                    id="email"
                    name="email"
                    type="email"
                    placeholder="you@example.com"
                    className="w-full rounded-md border border-[#E5E5E5] px-3 py-2 text-base font-source text-black focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-sm text-red-500"
                  />
                </div>

                {/* College Select */}
                <div className="flex flex-col space-y-2">
                  <label
                    htmlFor="collegeName"
                    className="text-sm font-source font-semibold text-black"
                  >
                    College<span className="text-red-500">*</span>
                  </label>
                  <Field
                    as="select"
                    id="collegeName"
                    name="collegeName"
                    className="w-full rounded-md border border-[#E5E5E5] px-3 py-2 text-base font-source text-black bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                  >
                    <option value="">Select your college</option>
                    <option value="RCPIMRD">RCPIMRD</option>
                  </Field>
                  <ErrorMessage
                    name="collegeName"
                    component="div"
                    className="text-sm text-red-500"
                  />
                </div>

                {/* Reason */}
                <div className="flex flex-col space-y-2">
                  <label
                    htmlFor="reason"
                    className="text-sm font-source font-semibold text-black"
                  >
                    Reason to delete<span className="text-red-500">*</span>
                  </label>
                  <Field
                    as="textarea"
                    id="reason"
                    name="reason"
                    rows="4"
                    placeholder="Please share the reason for deleting your account"
                    className="w-full rounded-md border border-[#E5E5E5] px-3 py-2 text-base font-source text-black resize-y focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                  />
                  <ErrorMessage
                    name="reason"
                    component="div"
                    className="text-sm text-red-500"
                  />
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-2 text-base font-source font-semibold text-white hover:bg-primary/90 disabled:opacity-70 disabled:cursor-not-allowed transition-colors bg-logo"
                >
                  {isSubmitting ? "Submitting..." : "Submit Request"}
                </button>
              </Form>
            )}
          </Formik>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeleteAccount;
